import {
    VIRTUAL_LOCKER_LIST,
    VIRTUAL_LOCKER_LIST_FAIL,
    VIRTUAL_LOCKER_LIST_SUCCESS,
    VIRTUAL_LOCKER_STATUS_CHANGE,
    VIRTUAL_LOCKER_STATUS_CHANGE_FAIL,
    VIRTUAL_LOCKER_STATUS_CHANGE_SUCCESS,
} from "../../actions/admin/customer-actions";
import { call, put, takeLatest, } from "redux-saga/effects";
import toast from "react-hot-toast";
import { API } from "../../api";

function* LockerList(action) {
    try {
        const response = yield call(API.lockerList, action.payload);
        yield put({ type: VIRTUAL_LOCKER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        const message =
            error?.data?.message ||
            error?.response?.data?.message ||
            "Failed to load virtual lockers";
        toast.error(message);
        yield put({ type: VIRTUAL_LOCKER_LIST_FAIL, payload: { error: error } });
    }
}

function* lockerStatusChange(action) {
    try {
        const { onSuccess, id, status } = action.payload || {};
        const response = yield call(API.lockerStatusChange, { id, status });
        yield put({ type: VIRTUAL_LOCKER_STATUS_CHANGE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
            onSuccess();
        }
    } catch (error) {
        yield put({ type: VIRTUAL_LOCKER_STATUS_CHANGE_FAIL, payload: { error: error } });
    }
}

function* lockerSaga() {
    yield takeLatest(VIRTUAL_LOCKER_LIST, LockerList);
    yield takeLatest(VIRTUAL_LOCKER_STATUS_CHANGE, lockerStatusChange);
}
export default lockerSaga;
